import React, { memo } from "react";
import NodeWrapper from "./NodeWrapper";
import { Description } from "@mui/icons-material";

/**
 * Send Template — Enviar template HSM aprovado (WhatsApp Business API).
 *
 * data.templateName: string — nome do template aprovado
 * data.templateLanguage: string — idioma (ex: "pt_BR")
 * data.templateParams: [string] — parametros do template ({{1}}, {{2}}, etc)
 * data.templateNamespace: string — namespace do template (opcional)
 *
 * Saida: handle "a" (default)
 */
const SendTemplateNode = memo(({ id, data, isConnectable, selected }) => {
  const name = data?.templateName || "";
  const lang = data?.templateLanguage || "pt_BR";
  const params = data?.templateParams || [];

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Description />}
      title="Enviar Template"
      color="#2E7D32"
      bgColor="#E8F5E9"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      {/* Template name */}
      <div style={{
        background: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 6,
        padding: "5px 10px",
        display: "flex",
        alignItems: "center",
        gap: 6,
      }}>
        <Description style={{ fontSize: 14, color: "#2E7D32" }} />
        <span style={{
          fontSize: 12, fontWeight: 600, color: "#1B5E20",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }}>
          {name || "Template nao selecionado"}
        </span>
      </div>

      {/* Info row */}
      <div style={{
        display: "flex", alignItems: "center", gap: 8,
        marginTop: 6, fontSize: 10, color: "#999",
      }}>
        <span style={{
          background: "#E8F5E9", border: "1px solid #C8E6C9",
          borderRadius: 3, padding: "1px 6px", fontWeight: 600,
        }}>
          {lang}
        </span>
        {params.length > 0 && (
          <span>{params.length} param{params.length > 1 ? "s" : ""}</span>
        )}
      </div>
    </NodeWrapper>
  );
});

SendTemplateNode.displayName = "SendTemplateNode";
export default SendTemplateNode;
